import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReusableTable from "../components/ReusableTable";
import { getApiUrl } from "../utils/api";
import { BASE_URL } from "../utils/api";
import { useNavigate } from "react-router-dom";

const Productmanagement = () => {
  const navigate = useNavigate();

  const UserId = "66abc123def4567890abcd12";

  const [products, setProducts] = useState([]);

  const fetchProducts = async () => {
    try {
      const res = await fetch(getApiUrl("product-list"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userid: UserId }),
      });

      const result = await res.json();
      if (result.success) {
        setProducts(result.data);
      }
    } catch (error) {
      toast.error("Failed to fetch product list");
    }
    console.log(getApiUrl("product-list"));
  };
  const handleEdit = (product) => {
    navigate("/bsk-secure-admin/new-product", { state: { product } });
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  const handleDelete = async (id) => {
    const res = await fetch(getApiUrl("product-delete"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ productid: id }),
    });

    const result = await res.json();
    if (result.success) {
      toast.success("Product Deleted Successfully!");
      fetchProducts();
    }
  };

  const columns = [
    { name: "Product Name", selector: (row) => row.productName },
    { name: "Price", selector: (row) => `₹ ${row.price}` },
    { name: "Discount", selector: (row) => `${row.discount}%` },
    {
      name: "Image",
      cell: (row) => (
        <img
          src={`${BASE_URL}${row.mainImage}`}
          alt={row.productName}
          width="60"
          height="60"
          style={{ borderRadius: "8px", objectFit: "cover" }}
        />
      ),
    },
    {
      name: "Actions",
      cell: (row) => (
        <>
          <button
            className="btn btn-warning btn-sm me-2" 
            onClick={() => handleEdit(row)}
          >
            <i className="fa-regular fa-pen-to-square"></i>
          </button>

          <button
            className="btn btn-danger btn-sm"
            onClick={() => handleDelete(row._id)}
          >
            <i className="fa-regular fa-trash-can"></i>
          </button>
        </>
      ),
    },
  ];

  return (
    <div className="container mt-4">
      <ToastContainer position="top-right" autoClose={3000} />

      <div className="d-flex justify-content-between mb-3">
        <h3 className="fw-bold">Product Management</h3>
        <button
          className="btn btn-primary"
          onClick={() => navigate("/bsk-secure-admin/new-product")}
        >
          + Add Product
        </button>
      </div>

      <ReusableTable columns={columns} data={products} title="Product List" />
    </div>
  );
};

export default Productmanagement;
